<bit-dialog dialogSize="large">
  <span bitDialogTitle>{{ "newExperienceDialogTitle" | i18n }}</span>
  <button
    bitDialogHeaderEnd
    type="button"
    bitIconButton="bwi-close"
    buttonType="primaryGhost"
    size="default"
    id="new-experience-dialog_button_close"
    [label]="'close' | i18n"
    (click)="close()"
  ></button>
  <div bitDialogContent>
    <img
      class="tw-w-full tw-rounded-lg"
      [src]="params.lightImgSrc"
      [appDarkImgSrc]="params.darkImgSrc"
      [alt]="'newExperienceDialogImgAlt' | i18n"
    />
    <p bitTypography="body1" noMargin class="tw-mt-4 tw-text-fg-body-subtle">
      {{ "newExperienceDialogDesc" | i18n }}
    </p>
  </div>
  <div #footer bitDialogFooter class="tw-flex tw-w-full tw-flex-wrap tw-gap-2">
    <button
      type="button"
      bitButton
      endIcon="bwi-arrow-right"
      buttonType="primary"
      [class.tw-grow]="stacked()"
      id="new-experience-dialog_button_explore"
      (click)="explore()"
    >
      {{ "exploreTheNewVault" | i18n }}
    </button>
    <a
      bitButton
      buttonType="secondary"
      [class.tw-grow]="stacked()"
      endIcon="bwi-external-link"
      [href]="learnMoreUrl"
      target="_blank"
      rel="noreferrer"
      id="new-experience-dialog_anchor_learn-more"
      (click)="learnMore($event)"
    >
      {{ "learnMore" | i18n }}
    </a>
  </div>
</bit-dialog>
